<template>
  <div class="kydt">
    <div class="title1" v-show="showList">承办会议</div>
    <list-four-vue :columnId="column_id" @detail="detail" v-if="showList"></list-four-vue>
    <detailVue :articleId="article_id" v-if="!showList"></detailVue>
  </div>
</template>
<script>
import detailVue from '../../components/detail.vue';
import listFourVue from '../../components/listOne.vue';
export default {
  components: {
    listFourVue,
    detailVue
  },
  data() {
    return {
      showList: true,
      column_id: '',
      article_id: ''
    }
  },
  created() {
    this.column_id = this.$route.query.column_id
  },
  beforeDestroy() {
    // 在组件销毁前，移除 popstate 事件监听
    window.removeEventListener('popstate', this.onPopState)
  },
  methods: {
    onPopState(e) {

      if (this.showList == false) {
        this.showList = true
        // window.history.pushState(null, null, window.location.href)
      } else {
        window.removeEventListener('popstate', this.onPopState)
        //  window.history.go(-1)
        this.$router.replace({ path: '/' })
      }
    },
    detail(item) {
      if (item.redirection_address) {
        window.open(item.redirection_address);
      } else {
        this.article_id = item.article_id
        this.showList = false
      }
    }
  },
  mounted() {
    // 添加 popstate 事件监听
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', this.onPopState);
  },
  watch: { // 监听，当路由发生变化的时候执行
    $route(to, from) {
      this.showList = true
    }
  }
};
</script>

<style lang="less" scoped>
.title1 {
  text-align: center;
  font-size: 22px;
  margin: 10px 0 30px;
}
</style>